// extracted by mini-css-extract-plugin
module.exports = {"root":"LoaderOverlay_root__t_ira","rotation":"LoaderOverlay_rotation__ZA5eJ"};